import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { CAMPAIGN_SETTINGS_PUBLISHERS_FRAGMENT } from '../fragments/campaignSettingsPublishers.fragment';
import {
  CampaignSettingsPublishersQuery,
  CampaignSettingsPublishersQueryVariables
} from './__generated__/CampaignSettingsPublishersQuery';

export const CAMPAIGN_SETTINGS_PUBLISHERS_QUERY = gql`
  query CampaignSettingsPublishersQuery($first: Int, $search: String) {
    publishers(first: $first, search: $search) {
      edges {
        node {
          ...PublisherFragment
        }
      }
    }
  }
  ${CAMPAIGN_SETTINGS_PUBLISHERS_FRAGMENT}
`;

export const useCampaignSettingsPublishersLazyQuery = () => {
  return useLazyQuery<CampaignSettingsPublishersQuery, CampaignSettingsPublishersQueryVariables>(
    CAMPAIGN_SETTINGS_PUBLISHERS_QUERY,
    { client: kmsClient, fetchPolicy: 'network-only', notifyOnNetworkStatusChange: true }
  );
};
